import React from "react";
import HolidayRevertVersion from "./../../../function_manual/components/holiday/revert.version";

const RevertVersion = (props) => {
    if (props.formName === "config_holidays") return <HolidayRevertVersion {...props} />;
    else return <div></div>;
};

export default RevertVersion;
